
    import { defineComponent } from 'vue'
    export default defineComponent({
        name: 'ModalBack',
        data() {
            return {
                title: "¡Atención!",
                messagePrimary: "Si modificás alguno de los datos ingresados, deberás iniciar una nueva cotización.",
                messageSecundary: "Caso contrario, te sugerimos continuar con la cotización en curso.",
                buttons: {
                    accept: 'Nueva cotización',
                    cancel: 'Continuar cotización'
                }
            }
        },
    })
